import SurfaceCard from "@/components/primitives/SurfaceCard";
import { MiniBars, NoteLine, SectionHead, StatGrid, hasStatValue } from "@/components/organization/kit";

interface ProductionMetricsProps {
  /** Pre-formatted, nullable marketing stats (org-published, full-team output). */
  annualVolume: string | null;
  transactions: string | null;
  avgSalePrice: string | null;
  yoyGrowth: string | null;
  /** Quarterly volume in $M; empty → the sub-block is omitted. */
  quarterly: { label: string; value: number }[];
  reportingYear?: string;
}

const ProductionMetrics = ({
  annualVolume,
  transactions,
  avgSalePrice,
  yoyGrowth,
  quarterly,
  reportingYear,
}: ProductionMetricsProps) => {
  const items = [
    { label: "Annual volume", value: annualVolume },
    { label: "Transactions", value: transactions },
    { label: "Avg. sale price", value: avgSalePrice },
    { label: "YoY growth", value: yoyGrowth },
  ];
  const hasStats = items.some((s) => hasStatValue(s.value));
  const hasQuarterly = quarterly.length > 0;
  // Nothing published → no card. Absent sub-blocks are omitted, never "not shared".
  if (!hasStats && !hasQuarterly) return null;

  return (
    <SurfaceCard padding="lg" className="rounded-2xl">
      <SectionHead
        kicker="Production"
        title="Volume & transactions"
        aside={
          <span className="text-xs text-ink-500">
            Self-reported{reportingYear ? ` · FY ${reportingYear}` : ""}
          </span>
        }
      />
      {hasStats && <StatGrid items={items} cols={4} />}

      {hasQuarterly && (
        <div className={hasStats ? "mt-[22px]" : undefined}>
          <div className="eyebrow mb-3.5 text-[10px] text-ink-500">Quarterly volume</div>
          <MiniBars data={quarterly} prefix="$" unit="M" />
        </div>
      )}

      <NoteLine>
        Production figures are self-reported by the organization and reflect full-team output, not per-agent.
      </NoteLine>
    </SurfaceCard>
  );
};

export default ProductionMetrics;
